import { CSSProperties } from "react";

import { useTheme } from "@hooks";

export const useStyles = (): Record<string, CSSProperties> => {
  const { theme } = useTheme();

  return {
    container: {
      maxWidth: 560,
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    linkRow: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 4,
      padding: "0 16px",
      height: 52,
      borderRadius: 14,
      border: `1px solid ${theme.border}`,
      background: theme.input.background,
    },
    baseUrl: {
      fontSize: 14,
      color: theme.text.secondary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    codeInput: {
      flex: 1,
      minWidth: 60,
      border: "none",
      outline: "none",
      background: "transparent",
      fontSize: 14,
      fontWeight: 600,
      color: theme.text.default,
      fontFamily: "inherit",
      padding: 0,
    },
    iconButton: {
      border: "none",
      background: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      padding: 6,
      color: theme.text.secondary,
    },
    message: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      fontSize: 13,
      minHeight: 20,
    },
    success: {
      color: theme.text.default,
    },
    error: {
      color: theme.text.error,
    },
    footer: {
      fontSize: 12,
      color: theme.text.secondary,
    },
    cta: {
      width: "100%",
      maxWidth: 360,
    },
  };
};
